export const API_BASE_URL = "https://app.chile-turismo.cl";
